import React from "react";
import classNames from "classnames";

import { GoogleAnalyticsHelper, Icon, Icomoon, PrimaryButton } from "@travellocal/ui";
import { LinkButton } from "./../../core/atoms/atoms";
import { api } from "./../../shared/api/system/apiClient";

import "./generatePdfButton.scss";

interface Props {
  itineraryId: number;
  inline?: boolean;
  gAEventLabel?: string;
  className?: string;
}

interface LocalState {
  jobId?: string;
  generating?: boolean;
  pdfUrl?: string;
}

export class GeneratePdfButton extends React.Component<Props, LocalState> {
  private readonly pollInterval = 1000;

  constructor(props: Props) {
    super(props);
    this.state = { jobId: null, generating: false, pdfUrl: "" };
  }

  private generateJob() {
    this.setState({ generating: true });

    GoogleAnalyticsHelper.logEvent("Download", "Click", this.props.gAEventLabel);

    api.generatePdfJob(this.props.itineraryId)
      .then((r) => {
        this.setState({ jobId: (r.json as number).toString() }, () => {
          this.pollForChanges();
        });
      })
      .catch((e) => {
        // TODO make this better
        console.error(e);
        this.setState({ generating: false, pdfUrl: null });
      });
  }

  private pollForChanges() {
    api.pollPdfJob(this.state.jobId)
      .then((r) => {
        const pollResponse = r.json;
        switch (pollResponse.status) {
          case PdfJobStatus.Done:
            this.setState({ generating: false, pdfUrl: pollResponse.url });
            break;
          case PdfJobStatus.Pending:
            window.setTimeout(() => {
              this.pollForChanges();
            }, this.pollInterval);
            break;
          case PdfJobStatus.Failed:
            this.setState({ generating: false, pdfUrl: "" });
            break;
        }
      })
      .catch((e) => {
        // TODO make this better
        // tslint:disable-next-line:no-console
        console.error(e);
        this.setState({ generating: false, pdfUrl: null });
      });
  }

  public render() {
    const { inline, className } = this.props;

    const style: React.CSSProperties = { display: inline ? "inline-block" : "block" };

    if (this.state.pdfUrl) {
      return (
        <LinkButton
          target="_blank"
          className={classNames("generate-pdf-button", className)}
          to={this.state.pdfUrl}
          icomoon={Icomoon.filePdf}
          iconAlign="right"
          style={style}
        >
          Open itinerary PDF
        </LinkButton>
      );
    }
    else {
      return (
        <PrimaryButton
          className={classNames("generate-pdf-button", className)}
          disabled={this.state.generating}
          onClick={() => this.generateJob()}
          style={style}
        >
          {this.state.generating ? "Please wait..." : "Download itinerary"} <Icon icomoon={Icomoon.filePdf} />
        </PrimaryButton>
      );
    }
  }
}
